<div class="spinner-border" [ngStyle]="{color}" role="status"></div>
